import { useQuery } from "@tanstack/react-query";

import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { AppError, RecoveryAuditReportResponse } from "@/types";

export type RecoveryAuditReportSearchParams = {
  page: number;
  limit: number;
  sortBy: string;
  sortDirection: "asc" | "desc";
  accountId?: string;
  organizationName?: string;
  status?: string;
  eventType?: string;
  from?: string;
  to?: string;
};

export const useRecoveryAuditReport = (params: RecoveryAuditReportSearchParams) => {
  return useQuery<RecoveryAuditReportResponse, AppError>({
    queryKey: ["recovery-audit-report", params],
    queryFn: async () => {
      const query = new URLSearchParams({
        page: String(params.page),
        limit: String(params.limit),
        sortBy: params.sortBy,
        sortDirection: params.sortDirection,
      });
      if (params.organizationName) query.set("organizationName", params.organizationName);
      if (params.accountId) query.set("accountId", params.accountId);
      if (params.status) query.set("status", params.status);
      if (params.eventType) query.set("eventType", params.eventType);
      if (params.from) query.set("from", params.from);
      if (params.to) query.set("to", params.to);

      return fetchApi(`${API_URL}/reports/recovery?${query.toString()}`);
    },
    placeholderData: (prev) => prev,
  });
};
